<template>
  <b-card no-body>
    <b-card-header>
      <h3 class="mb-0">Goal/Gap</h3>
    </b-card-header>
    <b-container fluid class="mt-4">
      
      <loading-panel v-if="loading"></loading-panel>
      <div id="goal-gap" v-else>
        <days-left :listingStats="listingStats" :transactionStats="transactionStats" :year="year" :transactionYear="transactionYear"></days-left>
        <b-row>
          <b-col md="6">
            <b-card no-body class="mb-3">
              <b-row class="px-3 pt-2">
                <b-col>
                  <base-input label="Listing Year" label-for="yearInput">
                    <el-select v-model="year">
                      <el-option v-for="year in years"
                                 :key="year.label"
                                 :label="year.label"
                                 :value="year.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
              </b-row>
            </b-card>
            <listing-stats :stats="yearlyListingStats" v-if="yearlyListingStats"></listing-stats>
          </b-col>
          <b-col md="6">
            <b-card no-body class="mb-3">
              <b-row class="px-3 pt-2">
                <b-col>
                  <base-input label="Transaction Year" label-for="yearInput">
                    <el-select v-model="transactionYear">
                      <el-option v-for="year in years"
                                 :key="year.label"
                                 :label="year.label"
                                 :value="year.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
              </b-row>
            </b-card>
            <transaction-stats :stats="yearlyTransactionStats" v-if="yearlyTransactionStats"></transaction-stats>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </b-card>
</template>
<script>
import axios from 'axios';
import {Select, Option} from 'element-ui';
import { mapGetters } from 'vuex';
import LoadingPanel from '@/components/LoadingPanel';
import DaysLeft from '@/views/Portal/GoalGap/GoalGap/DaysLeft';
import ListingStats from '@/views/Portal/GoalGap/GoalGap/ListingStats';
import TransactionStats from '@/views/Portal/GoalGap/GoalGap/TransactionStats';
import economicModelFormData from '@/views/Components/Forms/FormData/economicModelFormData';
import cosFormData from '@/views/Components/Forms/FormData/cosFormData';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    LoadingPanel,
    DaysLeft,
    ListingStats,
    TransactionStats
  },
  data() {
    return {
      loading: true,
      year: new Date().getFullYear(),
      transactionYear: new Date().getFullYear(),
      listingStats: null,
      transactionStats: null,
      yearlyListingStats: null,
      yearlyTransactionStats: null,
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
      economicModel: 'economicModel/economicModel',
    })
  },
  methods: {
    checkEconomicModel() {
      axios.get(this.userRoute + "/economic-model?year=" + this.year)
      .then(response => {
        if (response.data.id) {
          this.getListingStats();
          this.getYearlyListingStats(this.year);
        } else {
          this.$bvModal.show('no-economic-model');
        }
      });

      axios.get(this.userRoute + "/economic-model?year=" + this.transactionYear)
      .then(response => {
        if (response.data.id) {
          this.getTransactionStats();
          this.getYearlyTransactionStats(this.transactionYear);
        } else {
          this.$bvModal.show('no-economic-model');
        }
      });

      this.loading = false;
    },
    async getListingStats() {
      await axios.get(this.userRoute + "/goal-gap/listing-stats?year=" + this.year)
      .then(response => {
        this.listingStats = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async getTransactionStats() {
      await axios.get(this.userRoute + "/goal-gap/transaction-stats?year=" + this.transactionYear)
      .then(response => {
        this.transactionStats = response.data;
        var endDate = new Date(this.transactionStats.end_date).getFullYear();

        if (endDate > this.transactionYear) {
          this.transactionYear = endDate;
        }
      })
      .catch(error => {
        // 
      });
    },
    async getYearlyListingStats(year) {
      await axios.get(this.userRoute + "/goal-gap/yearly-listing-stats?year=" + year)
      .then(response => {
        this.yearlyListingStats = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async getYearlyTransactionStats(year) {
      await axios.get(this.userRoute + "/goal-gap/yearly-transaction-stats?year=" + year)
      .then(response => {
        this.yearlyTransactionStats = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async getContractYear()
    {
      await axios.get(this.userRoute + '/team/year')
      .then(response => {
        this.year = response.data;
        this.checkEconomicModel();
      })
      .catch(error => {
        // 
      });
    }
  },
  created() {
    this.getContractYear();
  },
  mounted() {
    document.title = this.year + ' Goal/Gap';
  },
  watch: {
    year(to, from) {
      this.getYearlyListingStats(to);
    },
    transactionYear(to, from) {
      this.getYearlyTransactionStats(to);
    }
  }
};
</script>